import { AlertTriangle } from "lucide-react";

/**
 * Important Safety Information block for SPRAVATO®.
 * Extracted from Spravato.tsx to keep the page file within size limits.
 */
export const SpravatoSafetyInfo = () => (
  <section className="relative bg-light-blue/40 py-16 lg:py-24">
    <div className="container-px mx-auto max-w-3xl">
      <div className="flex items-center gap-3">
        <AlertTriangle className="h-6 w-6 text-accent" />
        <h2 className="font-headings text-xl font-bold text-primary sm:text-2xl">
          Important Safety Information
        </h2>
      </div>
      <div className="mt-6 space-y-4 rounded-2xl border border-border bg-card p-6 shadow-soft sm:p-8">
        <p className="text-[15px] leading-relaxed text-foreground">
          SPRAVATO® has Boxed Warnings for sedation; dissociation; respiratory
          depression; abuse and misuse; and increased risk of suicidal thoughts
          and behaviors.
        </p>
        <p className="text-[15px] leading-relaxed text-foreground">
          SPRAVATO® can cause sleepiness, fainting, dizziness, spinning
          sensation, anxiety, dissociation, and breathing problems. Patients
          must be monitored by a healthcare provider for at least 2 hours after
          each dose. There is a risk of abuse and misuse, which may lead to
          physical and psychological dependence. Antidepressant medicines may
          increase suicidal thoughts and actions in some people 24 years of age
          and younger. SPRAVATO® is not for use in children.
        </p>
        <p className="text-[15px] leading-relaxed text-foreground">
          Because of these risks, SPRAVATO® is only available through a
          restricted program called the SPRAVATO® REMS.
        </p>
        <p className="text-[15px] leading-relaxed text-foreground">
          Do not take SPRAVATO® if you have aneurysmal vascular disease, an
          arteriovenous malformation, a history of bleeding in the brain, or an
          allergy to esketamine or ketamine.
        </p>
        <p className="text-[15px] leading-relaxed text-foreground">
          Do not drive or operate machinery until the next day after a restful
          sleep.
        </p>
        <p className="text-[15px] leading-relaxed text-foreground">
          The most common side effects include feeling disconnected from
          yourself, your thoughts, feelings and surroundings; dizziness; nausea;
          sleepiness; spinning sensation; numbness; anxiety; lack of energy;
          increased blood pressure; vomiting; feeling drunk; headache; and
          feeling very happy or excited. If these occur, they usually happen
          right after taking SPRAVATO® and go away the same day.
        </p>
        <p className="text-[15px] leading-relaxed text-foreground">
          Please see the full{" "}
          <a
            href="https://www.spravato.com/prescribing-information"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-accent underline underline-offset-4 hover:opacity-80"
          >
            Prescribing Information
          </a>
          , including Boxed Warnings, and the{" "}
          <a
            href="https://www.spravato.com/medication-guide"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-accent underline underline-offset-4 hover:opacity-80"
          >
            Medication Guide
          </a>
          , and discuss any questions with your healthcare provider.
        </p>
        <p className="text-[15px] leading-relaxed text-muted-foreground">
          SPRAVATO® is a registered trademark of Johnson & Johnson and its
          affiliates. Neuro Wellness TMS Centers of America is not affiliated
          with or endorsed by Johnson & Johnson.
        </p>
      </div>
    </div>
  </section>
);
